import { Component, OnInit, OnDestroy } from '@angular/core';
import { Utility } from '../shared/utility/utility';
import { EmitterService } from '../services/emitter.service';
import { environment } from '../../environments/environment';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  landingPage = false;
  isUserLoggedin = false;
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    private utils: Utility,
    private emitterService: EmitterService
  ) {
    this.emitterService.landingpageSource$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.landingPage = status;
      status ?  localStorage.setItem("landingPage","true") : localStorage.removeItem("landingPage");
    });
  }

  ngOnInit() {
    this.callGTMEvent();
    this.isUserLoggedin = this.utils.isUserLoggedIn();
    this.emitterService.updateLoginStatus$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.isUserLoggedin = status;
    });
  }
  
  callGTMEvent(){
    /*GTM event for current viewing page*/
    if(!environment.hasLandingpage || !localStorage.getItem("landingPage")){
      this.utils.gtmEvent("currentViewingPage", {
        currentPage: "home"
      });
    } 
  }

  closeLandingPage(value) {
    this.landingPage = value;
  }
  
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
